import AppConstants from '../../config/app.constants';

class DepositPackingController {

    /*@ngInject*/
    constructor($state, $q, $rootScope, $scope, $window, BranchFundingSourceService, Modal, User, CurrencyService, SetupService, DateUtil, CarrierService,
                AtmResidualDepositService, AtmResidualService, $location, DenominationService, $translate, BulkCashService, Sound, Navigation, DataCounter,
                UserBranchFundingSourceService, RouteService, LocationDeliveryService, LocationService) {
        this.$q = $q;
        this.$state = $state;
        this.$window = $window;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.CurrencyService = CurrencyService;
        this.DateUtil = DateUtil;
        this.SetupService = SetupService;
        this.CarrierService = CarrierService;
        this.AtmResidualDepositService = AtmResidualDepositService;
        this.User = User;
        this.AtmResidualService = AtmResidualService;
        this.Modal = Modal;
        this.$location = $location;
        this.DenominationService = DenominationService;
        this.$translate = $translate;
        this.BulkCashService = BulkCashService;
        this.Sound = Sound;
        this.$rootScope = $rootScope;
        this.page = 1;
        this.total = 0;
        this.pageLimit = 10;
        this.maxPages = 10;
        this.Navigation = Navigation;
        this.DataCounter = DataCounter;
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.currencySymbol = '$';
        this.RouteService = RouteService;
        this.LocationDeliveryService = LocationDeliveryService;
        this.LocationService = LocationService;

        this.model = {
            fundingSourceId: null,
            branch: User.getUser().branchId,
            userId: User.getUser().id,
            currency: null,
            allCurrency: [],
            vaultDate: '',
            allCarrier: [],
            ledgerTransaction: [],
            allDenomination: [],
            stats: 'pending',
            trackingId: "",
            dateRanges: {
                startDate: null,
                endDate: null,
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            dateRangPickerOptions: {},
            dateRangPicker: {},
            denomination: [],
            account:'regular'
            // isManualDeposit: false,
            // isResidualDeposit: false
        }

        this.dateRangeOption = {
            startDate: null,
            endDate: null,
        }

        this.stats = {
            pending: 'pending',
            packed: 'packed',
            released: 'released'
        }

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 5000,
            maxPages: 10
        };

        this.ledgers = [
            {
                lable: "Regular",
                value: "regular"
            },
            {
                lable: "Emergency",
                value: "emergency"
            }
        ]

        this.paginationObj = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.loading = false;
        this.locationLists = [];
        this.pendingResidualData = [];
        this.SelectedPendingDeposit = [];
        this.maxAtmResidualDepositLimit = 0;
        this.isLimitExceed = false;
        this.depositLimitExceedMsg = "";
        this.residualIds = [];
        this.denominationsBreakdown = [];
        this.successMessage = "";
        this.pendingReleaseData = [];
        this.contents = [];
        this.setupFromLocation = "";
        this.releasedDeposit = [];
        this.pendingDepositTotal = 0;
        this.packedDepositTotal = 0;
        this.releasedDepositTotal = 0;
        this.errorMessage = "";
        this.isError = false;
        this.emergencyPackPreviewData = [];
        this.denominationIds = [];
        this.totalAmount = 0;
        this.toggleSelect = true;
        this.$rootScope.$broadcast('routeChange', '/app/deposit-packing');
        this.residuals = [];
        this.selectedDenomination = [];
        this.filterDenomination = [];
        this.isWarning = false;
        this.packPreviewError = '';
        this.cashDepositData = '';
        this.noRecords = 0;
        this.deliveryLocations = [];
        this.model.deliveryLocation = null;
        this.model.routeId = null;
        this.model.routeName = null;
        this.model.deliveryDate = null;
        this.routeList = [];
        this.loadingRoutes = false;
    }

    setCurrencySymbol() {
        if (!this.model || !this.model.currency || !Array.isArray(this.model.allCurrency)) {
            this.currencySymbol = '$';
            return;
        }

        const currencyId = this.model.currency;
        const currency = this.model.allCurrency.find(c => c.id === currencyId);
        this.currencySymbol = (currency && currency.symbol) ? currency.symbol : '$';
    }

    setCurrencySymbol() {
        if (!this.model || !this.model.currency || !Array.isArray(this.model.allCurrency)) {
            this.currencySymbol = '$';
            return;
        }

        const currencyId = this.model.currency;
        const currency = this.model.allCurrency.find(c => c.id === currencyId);
        this.currencySymbol = (currency && currency.symbol) ? currency.symbol : '$';
    }

    $onInit() {
        this.cashDepositData = this.DataCounter.getData();
        this.$q.all([
            this.SetupService.get(this.model.branch),
            this.getFundingSource('', 0),
            this.CurrencyService.all(null, 0, 100),
            this.getAllCarrier('', 0)
        ])
            .then((data) => {
                const date = moment(data[0].currentVaultDate);
                this.maxAtmResidualDepositLimit = data[0].limitPerATMDeposit;
                this.model.vaultDate = this.DateUtil.convertToDate(date);
                this.model.allCurrency = data[2].results.filter((obj)=> data[0].availableCurrencyIds && data[0].availableCurrencyIds.includes(obj.id));
                // this.model.currency = data[2].currencyId;
                this.minVaultDate = {
                    minDate: this.model.vaultDate
                };
                this.minDeliveryDate = { minDate: this.model.vaultDate };
                this.setupFromLocation = data[0].fromLocation;
                // this.model.currency = data[0].currency.id;
                this.model.date = this.model.vaultDate;
                if (!this.model.deliveryDate) {
                    this.model.deliveryDate = this.model.vaultDate;
                }
                this.setCurrencySymbol();
            })
            .then(() => {
                this.setDateRange(this.model.vaultDate, this.model.dateRanges, 'dateRangPickerOptions');
                this.model.dateRanges.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                this.model.dateRanges.endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');
            })
        // .then(() => {
        //     this.setDateRange(this.model.vaultDate, this.dateRangeOption, 'dateRangPicker');
        //     this.dateRangeOption.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
        //     this.dateRangeOption.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //     console.log(this.dateRangeOption.startDate);
        //     console.log(this.dateRangeOption.endDate);
        // })
    }

    setDateRange(date, dateRangeOption, modelValue) {
        let currentVaultDate = moment(date).format() || moment();
        this.model[modelValue] = {
            autoApply: true,
            // maxDate: moment(currentVaultDate).endOf('day').format('YYYY-MM-DD'),
            eventHandlers: {
                'apply.daterangepicker': () => {
                    return this.filterData();
                    // if (this.model.stats === this.stats.released) return this.filterData(dateRangeOption);
                    // if (this.model.stats === this.stats.pending) return this.seletDepositByDate(dateRangeOption);
                }
            },
            ranges: {
                'Today': [
                    moment().format('YYYY-MM-DD HH:mm:ss'),
                    moment().format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ]
            }
        }
    }

    // tab selection
    tabSelection(selectedValue) {
        delete this.successMessage;
        this.model.stats = selectedValue;
    }

    // Get fundingSource locations 
    fundingSourceSearchObj = (searchKey) => {
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branch
                    },
                    {
                        group: {
                            rules: [{
                                field: 'locationId',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'sourceName',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        };
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getFundingSource(searchKey, offset) {
        // const loadFundingSourceData = this.fundingSourceSearchObj(searchKey);
        this.UserBranchFundingSourceService.getBranchFundingSource(this.model.userId, this.model.branch)
            .then((data) => {
                if (offset === 0) {
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingFundingSourceData(data.results);
                }
                else {
                    const locations = this.mappingFundingSourceData(data.results);
                    this.locationLists = this.locationLists.concat(locations);
                }
            })
    }

    mappingFundingSourceData(locations) {
        return locations.map((location) => {
            return {
                Key: location.id + " | " + location.locationId + " | " + location.sourceName,
                Value: location.locationId,
                Id: location.id,
                LocationId: location.locationId,
                sourceName: location.sourceName,
                residualDeposit: location.residualDeposit,
                manualDeposit: location.manualDeposit,
                partialECDeposit: location.partialECDeposit,
                currencyId: location.currencyId
            }
        });
    }

    // Get Carriers
    carrierSearchObj = (searchKey) => {
        searchKey = searchKey || '';
        const searchObj = {
            branch: this.model.branch,
            queryText: '%' + searchKey + '%',
            // queryJSON: {
            //     rules: [
            //         {
            //             field: 'id',
            //             condition: 'like',
            //             data: '%' + searchKey + '%'
            //         },
            //         {
            //             field: 'name',
            //             condition: 'like',
            //             data: '%' + searchKey + '%'
            //         }
            //     ],
            //     operator: 'OR'
            // }
        };
        return searchObj
    }

    getAllCarrier(searchKey, offset) {
        const loadCarrierData = this.carrierSearchObj(searchKey);
        this.CarrierService.all(loadCarrierData, offset, AppConstants.defaultPageLimit)
            .then((data) => {
                if (offset === 0) {
                    this.totalRecord = data.total;
                    this.carrierLists = this.mappingCarrierData(data.results);
                }
                else {
                    const carriers = this.mappingCarrierData(data.results);
                    this.carrierLists = this.carrierLists.concat(carriers);
                }
            })
            .then(() => {
                setTimeout(() => {
                    this.loadDepositPacking();
                }, 1000)
            })
    }

    mappingCarrierData(carriers) {
        return carriers.map((crr) => {
            return {
                Key: crr.id + " | " + crr.name,
                Value: crr.id,
                Name: crr.name
            }
        });
    }

    // get pending deposit
    getPendingResiduals() {

        if (!this.model.fundingSourceId || !this.model.currency || !this.model.account) {
            return;
        }

        this.loading = true;
        this.AtmResidualDepositService.getPendingResidualDeposit(this.model.branch, this.model.fundingSourceId.Value, this.model.fundingSourceId.Id, this.model.currency, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit)
            .then((data) => {
                this.isError = false;
                if (data.totalRecords > 0) {
                    this.pendingResidualData = data;
                    this.pendingDepositTotal = data.totalRecords;
                    this.residuals = data;
                    this.denomGroup();
                }
                else {
                    this.reset();
                }
            })
            .then(() => {
                this.getSelectedResidualId();
            })
            .catch((err) => {
                this.reset();
                console.log(err);
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.loading = false;
            })
    }

    getSelectedResidualId() {
        this.residualIds.map((id) => {
            this.pendingResidualData.records.filter((data) => {
                if (data.atmResidualId == id) {
                    data.isSelected = true;
                }
            })
        })
    }

    buildErrorMessage(err) {
        if (!err || !err.data) return '';

        let message = err.data.message || '';

        if (Array.isArray(err.data.warnings) && err.data.warnings.length) {
            message += '<br><br>' + err.data.warnings.join('<br>');
        }

        return message;
    }

    reset() {
        delete this.successMessage;
        delete this.msg;
        this.isError = true;
        this.denominationsBreakdown = [];
        this.residualIds = [];
        this.pendingResidualData = [];
        this.model.trackingId = "";
        this.errorMessage = this.$translate.instant('atm_deposit_packing.no_data_found');
    }

    selectedDeposit(event, data, index) {
        delete this.successMessage;

        if (event.target.checked) {
            this.residualIds.push(data.atmResidualId);
        }
        else {
            const index = this.residualIds.indexOf(data.atmResidualId);
            this.residualIds.splice(index, 1);
        }
        this.packPreview();
        if (this.residualIds && this.residualIds.length) this.msg = this.$translate.instant('atm_deposit_packing.selected_residual', { total: this.residualIds.length });
        else delete this.msg;
    }

    packPreview() {
        if (this.residualIds.length) {
            this.model.loading = true;
            this.AtmResidualDepositService.residualPackPreview(this.model.branch, this.model.fundingSourceId.Value, this.model.fundingSourceId.Id, this.model.currency,
                this.model.trackingId, this.residualIds)
                .then((res) => {
                    this.denominationsBreakdown = res;
                    this.checkResidualDepositLimit(res.summary.totalAmount, res.summary.depositLimit);
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal(err.data.message)
                    }
                })
                .finally(() => {
                    this.model.loading = false;
                })
        }
        else {
            this.denominationsBreakdown = [];
            this.model.trackingId = "";
        }
    }

    // check deposit limit with branch Max ATM Residual Deposit
    checkResidualDepositLimit(totalDenomAmount, depositLimit) {
        if (totalDenomAmount > depositLimit) {
            this.isLimitExceed = true;
            this.depositLimitExceedMsg = this.$translate.instant('atm_deposit_packing.limit_exceed');
        }
        else {
            this.isLimitExceed = false;
            delete this.depositLimitExceedMsg;
        }
    }

    // pack residual deposit
    pack() {
        if (!this.model.deliveryLocation) {
            this.Modal.errorModal('Please select a delivery location');
            return;
        }
        if (!this.model.routeId) {
            this.Modal.errorModal('Please enter a route ID');
            return;
        }
        if (!this.model.deliveryDate) {
            this.Modal.errorModal('Please select a delivery date');
            return;
        }

        this.packLoader = this.loading;
        this.packLoader = true;

        const carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
        const toLocationId = this.model.deliveryLocation ? this.model.deliveryLocation.id : null;
        const routeId = this.model.routeId || null;
        const deliveryDate = this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null;

        this.AtmResidualDepositService.commitDeposit(this.model.branch, this.model.fundingSourceId.Value, this.model.fundingSourceId.Id, this.model.currency, this.model.trackingId,
            this.model.account, carrierId, this.model.userId, this.residualIds, toLocationId, routeId, deliveryDate)
            .then((data) => {
                this.successMessage = this.$translate.instant('atm_deposit_packing.packed', {
                    trackingId: this.model.trackingId
                })
                this.Sound.playSuccessBeep("#success_beep");
            })
            .then(() => {
                delete this.msg;
                this.model.deliveryLocation = null;
                this.model.routeSelection = null;
                this.model.routeId = null;
                this.model.routeName = null;
                this.model.deliveryDate = this.model.vaultDate;
                this.refreshData(); // refresh data after successfully deposit packed
            })
            .catch((err) => {
                console.log(err);
                this.Sound.PlayErrorBeep("#scanner_beep");
                if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                    return this.Modal.errorModal('error.95001')
                }
                else {
                    return this.Modal.errorModal(this.buildErrorMessage(err));
                }
            })
            .finally(() => {
                this.packLoader = false;
            })
    }

    refreshData() {
        this.pagination.page = 1;

        if (this.model.stats === this.stats.pending) { // load PendingResiduals, packedDeposit and released data
            this.denominationsBreakdown = [];
            this.residualIds = [];
            this.model.trackingId = "";
            this.loadPendingResiduals();
            this.pendingToRelease();
            this.showReleasedDeposit(); 
        }

        if (this.model.stats === this.stats.packed) { // load packedDeposit and releasedDeposit data
            this.paginationObj.page = 1;
            this.pendingToRelease();
            this.showReleasedDeposit();
        }
    }

    pageChange() {
        delete this.successMessage;
        this.loadPendingResiduals();
    }

    loadPendingResiduals() {
        this.getPendingResiduals();
    }

    isFormValidate() {
        return this.model.fundingSourceId && this.model.account && this.model.currency;
    }

    // load pending to relase residual deposit 
    pendingToRelease() {

        if (!this.model.fundingSourceId || !this.model.currency || !this.model.account) {
            return;
        }

        this.pendingPackLoader = this.loading;
        this.pendingPackLoader = true;

        const carrierId = this.model.carrierId ? this.model.carrierId.Value : null;

        this.AtmResidualDepositService.getPendingRelease(this.model.branch, this.model.fundingSourceId.Value, this.model.currency,
            this.model.account, carrierId, this.paginationObj.pageLimit, (this.paginationObj.page - 1) * this.paginationObj.pageLimit)
            .then((data) => {
                this.pendingReleaseData = data;
                this.packedDepositTotal = data.totalRecords;
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.pendingPackLoader = false;
            })
    }

    jumpToNextPage() {
        delete this.successMessage;
        this.pendingToRelease();
    }

    // show packed residual deposit info
    showContents(depositId) {
        const defer = this.$q.defer();

        this.contentLoader = this.loading;
        this.contentLoader = true;

        this.AtmResidualDepositService.contents(depositId, this.pageLimit, (this.page - 1) * this.pageLimit)
            .then((res) => {
                this.contents = res;
                defer.resolve(this.contents)
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.contentLoader = false;
            })
        return defer.promise;
    }

    // PrintManifest for ATM deposit
    printManifest(data, index) {
        this.obj = {
            data: data,
            setupFromLocation: this.setupFromLocation,
            toLocation: this.model.fundingSourceId,
            carrier: this.model.carrierId,
            account: this.model.account,
            currencySymbol: this.currencySymbol
        }
        const new_path = this.$state.href('printDepositPacking');
        window.w = window.open(new_path, '_blank');
        window.w.printData = this.obj;
    }

    printPackedDepositLabel(data) {
        const deliveryLocation = this.model.deliveryLocation || {};
        const locationInfo = {
            id: deliveryLocation.id || null,
            name: deliveryLocation.name || null,
            address: deliveryLocation.address || null,
            city: deliveryLocation.city || null,
            state: deliveryLocation.state || null,
            zip: deliveryLocation.zip || null
        };

        const denominations = (data.denominations || [])
            .filter(d => d && (d.amount || d.inputValue || d.units || d.totalAmount))
            .map((d) => ({
                id: d.icon || d.denominationId || d.id || '',
                amount: Number(d.units ? (Number(d.units) * Number(d.faceValue || 0)) : (d.amount || d.inputValue || d.totalAmount || 0)),
                symbol: d.symbol || this.currencySymbol
            }));

        const totalDenomAmount = denominations.reduce((total, denomination) => total + denomination.amount, 0);
        const isMultiDenomPack = denominations.length > 0;

        const shipmentDetails = [{
            trackingId: data.trackingId || this.model.trackingId,
            toLocationId: locationInfo.id,
            isLoadTrackingId: true,
            locationInfo: locationInfo,
            orderNo: null,
            orderType: 'BULKCASH',
            routeId: data.routeId || this.model.routeId || null,
            deliveryDate: data.deliveryDate || (this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null),
            pickupDate: null,
            amount: Number(data.totalAmount || 0),
            denominationId: !isMultiDenomPack ? (data.denominationId || null) : null,
            vaultDate: data.deliveryDate || (this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null),
            defRouteSequence: data.defRouteSequence != null ? data.defRouteSequence : null,
            denominations: denominations,
            shiptypeId: data.shiptypeId || 'BULKCASH',
            symbol: data.symbol || this.currencySymbol,
            fundingSource: this.model.fundingSourceId ? this.model.fundingSourceId.sourceName : null,
            totalDenomAmount: totalDenomAmount
        }];

        const obj = {
            shipmentDetails,
            isPrePackPrint: false,
            multiDenomPack: false,
            depositShipmentLabelPrePack: true,
            currencySymbol: this.currencySymbol
        };
        const path = this.$state.href('printBarcodes');
        window.w = window.open(path, '_blank');
        window.w.printData = obj;
    }

    relesePendingDeposit(data) {
        this.releaseLoader = {};
        this.releaseLoader[data.trackingId] = { process: true };
        const carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
        const carrierName = this.model.carrierId ? this.model.carrierId.Name : null;

        this.AtmResidualDepositService.release(data.id, this.isResidualDeposit(), this.model.branch, data.trackingId, carrierId, 
                                               carrierName, this.model.userId)
            .then((res) => {
                this.successMessage = this.$translate.instant('atm_deposit_packing.released', {
                    trackingId: data.trackingId
                })
                this.Sound.playSuccessBeep("#success_beep");
                this.refreshData(); // refresh data after successfully released 
            })
            .catch((err) => {
                console.log(err);
                this.Sound.PlayErrorBeep("#scanner_beep");
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.releaseLoader[data.trackingId].process = false;
            })
    }

    loadData() {
        this.pagination.page = 1;
        this.paginationObj.page = 1;
        this.model.pagination.page = 1;

        if (this.isFundingSourceValid()) {
            this.showReleasedDeposit();
            this.pendingToRelease();
            this.loadDeliveryLocations();
            this.model.currency = this.model.fundingSourceId.currencyId;
        }
    }

    loadDeliveryLocations() {
        if (!this.model.fundingSourceId || !this.model.fundingSourceId.LocationId) {
            this.validDeliveryLocationIds = [];
            this.deliveryLocations = [];
            this.totalDeliveryLocations = 0;
            this.model.deliveryLocation = null;
            this.model.routeId = null;
            this.model.deliveryDate = null;
            this.routeList = [];
            return;
        }

        const locationMap = {};
        const add = (loc) => { if (loc && loc.id) locationMap[loc.id] = { id: loc.id, name: loc.name || loc.id, Key: loc.id + ' | ' + (loc.name || loc.id), Value: loc.id }; };
        const centralBank = this.model.branch ? this.LocationService.centralBankLocation(this.model.branch).catch(() => []) : this.$q.resolve([]);
        this.$q.all([
            this.LocationDeliveryService.getLocationDeliveryDetails(this.model.fundingSourceId.LocationId),
            centralBank
        ]).then(([deliveryData, centralBankLocations]) => {
                (deliveryData || []).forEach((d) => d.destinationLocation && add(d.destinationLocation));
                (centralBankLocations || []).forEach(add);
                this.validDeliveryLocationIds = Object.keys(locationMap);

                if (this.validDeliveryLocationIds.length === 0) {
                     this.deliveryLocations = [];
                     this.totalDeliveryLocations = 0;
                     this.model.deliveryLocation = null;
                     this.loadRouteSchedule();
                     return;
                }

                // Initial fetch will figure out if we just have 1 location
                this.getDeliveryLocations('', 0).then(() => {
                    if (this.validDeliveryLocationIds.length === 1 && this.deliveryLocations.length === 1) {
                        this.model.deliveryLocation = this.deliveryLocations[0];
                        this.loadRouteSchedule();
                    } else {
                        this.model.deliveryLocation = null;
                        this.model.routeSelection = null;
                        this.model.routeId = null;
                        this.model.routeName = null;
                        this.routeList = [];
                    }
                });
            })
            .catch((err) => {
                console.error('Error loading delivery locations:', err);
                this.validDeliveryLocationIds = [];
                this.deliveryLocations = [];
                this.totalDeliveryLocations = 0;
                this.model.deliveryLocation = null;
                this.model.routeSelection = null;
                this.model.routeId = null;
                this.model.routeName = null;
                this.routeList = [];
                this.totalRoutes = 0;
            });
    }

    getDeliveryLocations(searchKey, offset) {
        if (!this.validDeliveryLocationIds || !this.validDeliveryLocationIds.length) {
            return this.$q.resolve();
        }
        
        searchKey = searchKey || '';
        const limit = 10;
        offset = offset || 0;

        const locationSearchObj = {
            queryJSON: {
                rules: [
                    { field: "id", condition: "IN", data: this.validDeliveryLocationIds },
                    {
                        group: {
                            rules: [
                                { field: "id", condition: "like", data: "%" + searchKey + "%" },
                                { field: "name", condition: "like", data: "%" + searchKey + "%" }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        };

        return this.LocationService.all(locationSearchObj, offset, limit)
            .then((data) => {
                const results = (data.results || []).map((loc) => ({
                    id: loc.id,
                    name: loc.name || loc.id,
                    Key: loc.id + ' | ' + (loc.name || loc.id),
                    Value: loc.id,
                    address: loc.address,
                    city: loc.city,
                    state: loc.state,
                    zip: loc.zip,
                    country: loc.country
                }));

                if (offset === 0) {
                    this.totalDeliveryLocations = data.total;
                    this.deliveryLocations = results;
                } else {
                    this.deliveryLocations = this.deliveryLocations.concat(results);
                }
            })
            .catch((err) => {
                console.error("Error fetching delivery locations:", err);
            });
    }

    onRouteChange() {
        if (this.model.routeSelection) {
            this.model.routeId = this.model.routeSelection.routeId;
            this.model.routeName = this.model.routeSelection.routeName;
        } else {
            this.model.routeId = null;
            this.model.routeName = null;
        }
    }

    loadRouteSchedule() {
        if (!this.model.deliveryLocation || !this.model.deliveryLocation.id || !this.model.branch) {
            this.routeList = [];
            this.totalRoutes = 0;
            this.model.routeSelection = null;
            this.model.routeId = null;
            this.model.routeName = null;
            return;
        }
        this.getRoutes('', 0);
    }

    getRoutes(searchKey, offset) {
        if (!this.model.deliveryLocation || !this.model.deliveryLocation.id || !this.model.branch) return;

        searchKey = searchKey || '';
        this.loadingRoutes = true;

        const routeSearchObj = {
            queryJSON: {
                rules: [
                    { field: "branchId", condition: "IN", data: [this.model.branch] },
                    {
                        group: {
                            rules: [
                                { field: "id", condition: "like", data: "%" + searchKey + "%" },
                                { field: "name", condition: "like", data: "%" + searchKey + "%" }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        };

        const deliveryDate = this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : (this.model.vaultDate ? moment(this.model.vaultDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'));
        
        let scheduledPromise = this.$q.resolve({ results: [] });
        if (offset === 0 || offset == undefined) {
             scheduledPromise = this.RouteService.getScheduledRouteByLocationId(deliveryDate, this.model.deliveryLocation.id, this.model.branch);
        }

        this.$q.all([
            scheduledPromise,
            this.RouteService.all(routeSearchObj, offset, 10)
        ]).then(([scheduledRoutes, allRoutes]) => {
            const branchRoutes = (allRoutes.results || []).map((route) => ({
                Key: `${route.id} | ${route.name || route.id}`,
                Value: route.id,
                routeId: route.id,
                routeName: route.name || route.id,
                isScheduled: false,
                isHold: !!route.holdRoute
            }));

            const scheduledIds = new Set((scheduledRoutes.results || []).map(route => route.id));
            branchRoutes.forEach(route => {
                if (scheduledIds.has(route.routeId)) {
                    route.isScheduled = true;
                }
            });

            if (offset === 0 || offset == undefined) {
                this.totalRoutes = allRoutes.total;
                const sortedRoutes = branchRoutes.sort((a, b) => {
                    if (a.isScheduled !== b.isScheduled) return a.isScheduled ? -1 : 1;
                    if (a.isHold !== b.isHold) return a.isHold ? 1 : -1;
                    return (a.routeName || '').localeCompare(b.routeName || '');
                });
                
                this.routeList = sortedRoutes;

                if (this.routeList.length > 0) {
                    const scheduledRoute = this.routeList.find(r => r.isScheduled);
                    if (scheduledRoute) {
                        this.model.routeSelection = scheduledRoute;
                        this.model.routeId = scheduledRoute.routeId;
                        this.model.routeName = scheduledRoute.routeName;
                    }
                }
            } else {
                 const currentIds = new Set(this.routeList.map(r => r.routeId));
                 const newRoutes = branchRoutes.filter(r => !currentIds.has(r.routeId));
                 this.routeList = this.routeList.concat(newRoutes);
            }
        }).catch((err) => {
            console.error(err);
        }).finally(() => {
            this.loadingRoutes = false;
        });
    }

    resetPendingResidualData() {
        if (this.model.fundingSourceId && this.model.fundingSourceId.residualDeposit && this.isFundingSourceValid()) {
            if (this.model.account === 'regular') {
                this.resetEmergencyPackPreview();
                this.getPendingResiduals();
            }
            if (this.model.account === 'emergency') {
                this.resetRegularPackPreview();
                this.getEmergencyPackingData();
            }
        }
    }

    // show released deposit data
    showReleasedDeposit() {
        if (!this.model.fundingSourceId || !this.model.currency || !this.model.account) {
            return;
        }

        this.releasedLoader = this.loading;
        this.releasedLoader = true;

        const rangeStart = (this.model.dateRanges && this.model.dateRanges.startDate) ? this.model.dateRanges.startDate : moment().startOf('week');
        const rangeEnd = (this.model.dateRanges && this.model.dateRanges.endDate) ? this.model.dateRanges.endDate : moment().endOf('week');
        const startDate = moment(rangeStart).format('YYYY-MM-DD') + 'T00:00:00.000Z';
        const endDate = moment(rangeEnd).format('YYYY-MM-DD') + 'T23:59:59.999Z';
        const carrierId = this.model.carrierId ? this.model.carrierId.Value : null;

        this.AtmResidualDepositService.released(this.model.branch, this.model.fundingSourceId.Value, this.model.currency,
            this.model.account, carrierId, startDate,
            endDate, this.model.pagination.pageLimit, (this.model.pagination.page - 1) * this.model.pagination.pageLimit)
            .then((res) => {
                this.releasedDeposit = res;
                this.releasedDepositTotal = res.totalRecords;
                this.autoOpenContentModal();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.releasedLoader = false;
            })
    }

    filterData() {
        this.model.pagination.page = 1;
        this.showReleasedDeposit();
    }

    nextPage() {
        this.showReleasedDeposit();
    }

    // show details of residual shipment details which is already has been packed or released
    packedDepositInfo(data) {
        this.Modal.depositPackingInfoModal(data, ({ modal }) => {
            modal.close();
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }

    getEmergencyPackingData() {

        if (!this.model.fundingSourceId || !this.model.currency || !this.model.account) {
            return;
        }

        this.emergencyPackLoader = this.loading;
        this.emergencyPackLoader = true;
        this.filterDenomination = [];

        this.AtmResidualDepositService.emergencyPackPreview(this.model.branch, this.model.fundingSourceId.Value, this.model.currency)
            .then((res) => {
                this.emergencyPackPreviewData = res;
                this.emergencyPackPreviewData.breakdown.forEach(denom => {
                    this.filterDenomination.push({
                        denominationId: denom.denominationId,
                        faceValue: denom.denominationFaceValue,
                        balance: denom.totalAmount
                    })
                })
                this.defaultDenominationArray();
                this.addRemainingDenominations(0);
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.emergencyPackLoader = false;
            })
    }

    resetRegularPackPreview() {
        delete this.successMessage;
        this.denominationsBreakdown = [];
        this.residualIds = [];
        this.pendingResidualData = [];
        this.model.trackingId = "";
    }

    selectedEmergencyPackPreview(event, data, index) {
        delete this.successMessage;
        this.totalAmount = 0;

        if (event.target.checked) {
            this.emergencyPackPreviewData.breakdown.forEach((d) => {
                this.denominationIds.push(d);
                d.isSelected = true;
            })
            this.getTotalAmount(this.denominationIds);
        }
        else {
            this.emergencyPackPreviewData.breakdown.forEach((d) => {
                const index = this.denominationIds.indexOf(d);
                this.denominationIds.splice(index, 1);
                d.isSelected = false;
            })
            this.getTotalAmount(this.denominationIds);
        }
        // this.checkResidualDepositLimit(res.summary.totalAmount, res.summary.depositLimit);
    }

    getTotalAmount(array) {
        array.forEach((d) => {
            this.totalAmount += d.totalAmount
        })
    }

    emergencyPack() {
        if (!this.model.deliveryLocation) {
            this.Modal.errorModal('Please select a delivery location');
            return;
        }
        if (!this.model.routeId) {
            this.Modal.errorModal('Please enter a route ID');
            return;
        }
        if (!this.model.deliveryDate) {
            this.Modal.errorModal('Please select a delivery date');
            return;
        }

        this.packEmergencyDeposit = this.loading;
        this.packEmergencyDeposit = true;

        const carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
        const toLocationId = this.model.deliveryLocation ? this.model.deliveryLocation.id : null;
        const routeId = this.model.routeId || null;
        const deliveryDate = this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null;
        
        this.AtmResidualDepositService.commitEmergencyDeposit(this.model.branch, this.model.fundingSourceId.Value, this.model.currency, this.model.trackingId,
            carrierId, this.model.userId, toLocationId, routeId, deliveryDate)
            .then((data) => {
                this.successMessage = this.$translate.instant('atm_deposit_packing.packed', {
                    trackingId: this.model.trackingId
                })
                this.Sound.playSuccessBeep("#success_beep");
            })
            .then(() => {
                this.model.deliveryLocation = null;
                this.model.routeSelection = null;
                this.model.routeId = null;
                this.model.routeName = null;
                this.model.deliveryDate = this.model.vaultDate;
                this.refreshEmergencyData(); // refresh data after successfully deposit packed
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                    return this.Modal.errorModal('error.95001')
                }
                else {
                    return this.Modal.errorModal(this.buildErrorMessage(err));
                }
            })
            .finally(() => {
                this.packEmergencyDeposit = false;
            })
    }

    refreshEmergencyData() {
        this.model.trackingId = "";
        this.denominationIds = [];
        this.pendingToRelease();
        this.getEmergencyPackingData();
        this.showReleasedDeposit();
    }

    resetEmergencyPackPreview() {
        delete this.successMessage;
        this.denominationIds = [];
        this.emergencyPackPreviewData = [];
        this.model.trackingId = "";
    }

    selectDepositByDate() {
        delete this.successMessage;
        this.residualIds = [];
        const date = moment(this.model.date).format('YYYY-MM-DD');

        if (this.pendingResidualData && this.pendingResidualData.records) {
            this.pendingResidualData.records.filter((d) => {
                if (moment.utc(d.countedDate).format('YYYY-MM-DD') === date) {
                    d.isSelected = true;
                    this.residualIds.push(d.atmResidualId)
                }
                else {
                    this.toggleSelect = true;
                    d.isSelected = false;
                }
            })
            this.packPreview();
        }
        if (this.residualIds && this.residualIds.length) this.msg = this.$translate.instant('atm_deposit_packing.selected_residual', { total: this.residualIds.length });
        else delete this.msg;
    }

    resetSelection() {
        this.denominationsBreakdown = [];
        this.model.trackingId = "";
        this.residualIds = [];
        this.pendingResidualData.records.filter((d) => {
            d.isSelected = false;
        })
        this.toggleSelect = true;
        delete this.successMessage;
        delete this.msg;
    }

    toggleAllSelection() {
        delete this.successMessage;
        this.residualIds = [];

        if (this.pendingResidualData && this.pendingResidualData.records) {
            this.pendingResidualData.records.filter((d) => {
                d.isSelected = this.toggleSelect;
                this.residualIds.push(d.atmResidualId);
            })
            this.toggleSelect = !this.toggleSelect;
            if (this.toggleSelect) { return this.residualIds = [], this.denominationsBreakdown = [], delete this.msg; }
            if (!this.toggleSelect) { return this.packPreview(), this.msg = this.$translate.instant('atm_deposit_packing.selected_residual', { total: this.residualIds.length }) }
        }
    }

    isValidate() {
        return this.model.fundingSourceId && this.model.account && this.model.currency;
    }

    exportPendingResidalData() {
        this.isExporting = true;
        this.AtmResidualDepositService.exportPendingPackData(
            this.model.branch,
            this.model.fundingSourceId.Value,
            this.model.fundingSourceId.Id,
            this.model.currency,
            this.currencySymbol,
            this.pagination.pageLimit,
            (this.pagination.page - 1) * this.pagination.pageLimit
        )
            .then((data) => {
                this.downloadFile(data, 'pending_pack')
            })
            .catch((err) => {
                this.isExporting = false;
                console.log(err);
            })
    }

    downloadFile(data, fileName) {
        this.reportPrefix = fileName;
        this.date = moment.utc().format('DDMMYY');
        this.fileName = this.reportPrefix.concat('_', this.date, '.csv');
        let a = document.createElement("a");
        document.body.appendChild(a);
        let file = new Blob([data.reportData], { type: 'application/csv' });
        let fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = this.fileName;
        a.click();
        this.isExporting = false;
    }

    exportPackedResidualData() {
        this.isExporting = true;
        const carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
        this.AtmResidualDepositService.exportPackedResidualData(
            this.model.branch,
            this.model.fundingSourceId.Value,
            this.model.currency,
            this.currencySymbol,
            this.model.account,
            carrierId,
            this.pagination.pageLimit,
            (this.pagination.page - 1) * this.pagination.pageLimit
        )
            .then((data) => {
                this.downloadFile(data, 'pending_release');
            })
            .catch((err) => {
                this.isExporting = false;
                console.log(err);
            })
    }

    exportReleasedResidualData() {
        this.isExporting = true;

        const startDate = moment(this.model.dateRanges.startDate).format('YYYY-MM-DD') + 'T00:00:00.000Z',
            endDate = moment(this.model.dateRanges.endDate).format('YYYY-MM-DD') + 'T23:59:59.999Z';

        const carrierId = this.model.carrierId ? this.model.carrierId.Value : null;

        this.AtmResidualDepositService.exportReleasedResidualData(
            this.model.branch,
            this.model.fundingSourceId.Value,
            this.model.currency,
            this.currencySymbol,
            this.model.account,
            carrierId,
            startDate,
            endDate,
            this.pagination.pageLimit,
            (this.pagination.page - 1) * this.pagination.pageLimit
        )
            .then((data) => {
                this.downloadFile(data, 'released')
            })
            .catch((err) => {
                this.isExporting = false;
                console.log(err);
            })
    }

    confirmUndoDeposit(data) {
        this.Modal.confirm({
            header: this.$translate.instant('atm_deposit_packing.undo_deposit_pack'),
            message: this.$translate.instant('atm_deposit_packing.undo_deposit_msg'),
            callback: ({
                modal
            }) => {
                modal.close();
                this.undoDeposit(data);
            },
            negative: (({
                modal,
            }) => {
                modal.close();
            }),
            type: 'danger'
        })
    }

    undoDeposit(data) {
        let force = false;
        this.AtmResidualDepositService.undoDepositPack(data.id, force)
            .then((res) => {
                this.reloadData(); // reload data after undo deposit
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                    return this.Modal.errorModal('error.95001')
                }
                else {
                    return this.Modal.errorModal(err.data.message);
                }
            })
    }

    reloadData() {
        if (this.model.account === 'regular') {
            this.model.fundingSourceId.manualDeposit ? this.getLedgerDenomBalance() : this.getPendingResiduals();
        }
        if (this.model.account === 'emergency') {
            this.model.fundingSourceId.manualDeposit ? this.getLedgerDenomBalance() : this.getEmergencyPackingData();
        }
        this.pendingToRelease();
    }

    printEmergencyPackedData() {
        const obj = {
            data: {
                branchId: this.model.branch,
                currency: this.model.currency,
                printEmergencyPackData: true,
                account: this.model.account
            },
            setupFromLocation: this.setupFromLocation,
            toLocation: this.model.fundingSourceId,
            carrier: this.model.carrierId,
            currencySymbol: this.currencySymbol
            // account: this.model.account
        }
        const new_path = this.$state.href('printDepositPacking');
        window.w = window.open(new_path, '_blank');
        window.w.printData = obj;
    }

    reloadPageData() {
        if (this.model.stats === this.stats.pending) {
            if (this.model.account === 'regular') this.getPendingResiduals();
            if (this.model.account === 'emergency') this.getEmergencyPackingData();
        }
        else if (this.model.stats === this.stats.packed) {
            this.pendingToRelease();
        }
        else {
            this.showReleasedDeposit();
        }
    }

    // create unique denomination group from existing pendingResidualData
    denomGroup() {
        this.denominationGroup = [];
        const uniqueDenoms = new Set();
        (this.pendingResidualData.records || []).forEach(record => {
            if (record.denominationId) {
                record.denominationId.split(',').forEach(d => {
                    uniqueDenoms.add(d.trim());
                });
            }
        });

        Array.from(uniqueDenoms).forEach((denomId) => {
            let icon = '<img  src="assets/images/' + denomId + '.png" />';
            this.denominationGroup.push({ icon: icon, denominationId: denomId });
        });
    }

    filterDataByDenom() {
        let results = [];
        let shipmentAmount = 0;
        if (this.model.denomination.length) {
            this.resetSelection();
            const selectedDenoms = this.model.denomination.map(d => d.denominationId);

            this.residuals.records.forEach((record) => {
                let recDenoms = record.denominationId ? record.denominationId.split(',').map(d => d.trim()) : [];
                if (recDenoms.some(d => selectedDenoms.includes(d))) {
                    shipmentAmount += (record.amount || 0);
                    results.push(record);
                }
            });
            this.pendingResidualData = {
                records: results,
                totalPendingDeposit: shipmentAmount,
                totalRecords: this.residuals.totalRecords
            }
        }
        else {
            this.resetSelection(); // reset denomination breakdown selection
            this.resetData(); //  reset filtered data by denom
        }
    }

    resetData() {
        this.resetSelection();
        return this.pendingResidualData = this.residuals;
    }

    isResidualDeposit() {
        return this.model.fundingSourceId && this.model.fundingSourceId.residualDeposit;
    }

    ///// Manual Deposit Logic //////
    getLedgerDenomBalance() {
        if (!this.isValidate()) {
            return;
        }

        this.isLoading = true;
        this.AtmResidualDepositService.ledgerDenomBalance(this.model.branch, this.model.account, this.model.fundingSourceId.Id)
            .then((data) => {
                this.model.ledgerData = {
                    ...data, 
                    results: data.results.filter((item) => item.balance > 0)
                };
                this.filterDenomination = this.model.ledgerData.results;
                this.defaultDenominationArray();
                this.addRemainingDenominations(0);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.isLoading = false;
            })
    }

    loadManualDepositData() {
        if (this.model.fundingSourceId && this.model.fundingSourceId.manualDeposit && this.isFundingSourceValid()) {
            this.model.stats = 'pending';
            this.resetDenomData();
            this.getLedgerDenomBalance();
        }
    }

    defaultDenominationArray() {
        this.denominationData = [
            {
                trackingId: '',
                account: this.model.account,
                denominations: [],
                remainingDenominations: [],
                totalAmount: '',
                isValid: false,
                currencyIcon: this.model.currency,
                denomTemplate: 'denomType-selection.html'
            }
        ];
    }

    addRow() {
        this.denominationData.push({
            trackingId: '',
            account: this.model.account,
            denominations: [],
            remainingDenominations: [],
            totalAmount: '',
            isValid: false,
            currencyIcon: this.model.currency,
            denomTemplate: 'denomType-selection.html'
        });
        if (this.filterDenomination) {
            this.addRemainingDenominations(this.denominationData.length - 1);
        }
        this.checkDuplicateTrackingIds();
    }

    removeRow(index) {
        let row = this.denominationData[index];
        let hasDenominations = row.denominations && row.denominations.length > 0;
        let hasTrackingId = row.trackingId && row.trackingId.trim().length > 0;

        let doDelete = () => {
            this.denominationData.splice(index, 1);
            this.checkDuplicateTrackingIds();
            this.denominationData.forEach((r, rIdx) => {
                r.denominations.forEach((denom, dIdx) => {
                    let val = denom.coinFlag ? denom.units : denom.amount;
                    this.checkAmount(rIdx, dIdx, denom.ledgerDenomBalance, val, denom.faceValue, denom.coinFlag);
                });
            });
        };

        if (hasDenominations || hasTrackingId) {
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('common.confirm_delete_message'),
                callback: (({ modal }) => {
                    doDelete();
                    modal.close();
                }),
                negative: (({ modal }) => {
                    modal.close();
                }),
                type: 'danger'
            });
        } else {
            doDelete();
        }
    }

    checkDuplicateTrackingIds() {
        if (!this.denominationData) return;
        
        let trackingIdCounts = {};
        this.denominationData.forEach((data) => {
            if (data.trackingId) {
                let id = data.trackingId.trim().toLowerCase();
                trackingIdCounts[id] = (trackingIdCounts[id] || 0) + 1;
            }
        });

        this.denominationData.forEach((data) => {
            if (data.trackingId) {
                let id = data.trackingId.trim().toLowerCase();
                data.isDuplicateTrackingId = trackingIdCounts[id] > 1;
            } else {
                data.isDuplicateTrackingId = false;
            }
        });
    }

    addDenomination(index) {
        let denomLength = this.denominationData[index].denominations.length;
        let defaultDenomIcon = this.filterDenomination[0].denominationId;
        let icon = denomLength ? this.denominationData[index].remainingDenominations[0].denominationId : defaultDenomIcon;
        let faceValue = 0;
        let ledgerDenomBalance = 0;
        let coinFlag = 0;
        let symbol = this.currencySymbol;

        this.filterDenomination.forEach((denomData) => {
            if (denomData.denominationId == icon) {
                faceValue = denomData.faceValue;
                ledgerDenomBalance = denomData.balance;
                coinFlag = denomData.coinFlag || 0;
                symbol = denomData.symbol || this.currencySymbol;
            }
        })

        this.denominationData[index].denominations.push({
            icon: icon,
            faceValue: faceValue,
            amount: null,
            units: null,
            inputValue: null,
            coinFlag: coinFlag,
            template: 'denomination-selection.html',
            ledgerDenomBalance: ledgerDenomBalance,
            symbol: symbol
        });

        let denomIndex = _.findIndex(this.denominationData[index].denominations, { icon: icon });
        this.setFocus(denomIndex);
        this.removeAlreadyUsedDenom(index);
    }

    addRemainingDenominations(index) {
        this.filterDenomination.forEach((data) => {
            this.denominationData[index].remainingDenominations.push(data);
        })
    }

    removeAlreadyUsedDenom(index) {
        this.denominationData[index].remainingDenominations = this.filterDenomination.filter(type => {
            let isValid = true;
            this.denominationData[index].denominations.forEach((data) => {
                isValid = (!(data.icon === type.denominationId)) && isValid
            })
            return isValid
        })
    }

    removeDenomination(parentIndex, denominationIndex) {
        let denom = this.denominationData[parentIndex].denominations[denominationIndex];
        this.denominationData[parentIndex].denominations.splice(denominationIndex, 1);
        let length = this.denominationData[parentIndex].denominations.length;
        this.calculateAmount(parentIndex, denominationIndex) // check and deduct amount if denom removed from array
        this.removeAlreadyUsedDenom(parentIndex);
        this.validateMsg(parentIndex);
        this.denominationData.forEach((row, rIdx) => {
            row.denominations.forEach((d, dIdx) => {
                let val = d.coinFlag ? d.units : d.amount;
                this.checkAmount(rIdx, dIdx, d.ledgerDenomBalance, val, d.faceValue, d.coinFlag);
            });
        });
        // if (length && !denom.isValid && denom.amount) this.adHocPackPreview(parentIndex);
    }

    changeDenomination(event, denomId, parentIndex, denominationIndex, imageIndex, faceValue, amount, ledgerDenomBalance, coinFlag, symbol) {
        let currentDenom = this.denominationData[parentIndex].denominations[denominationIndex];
        let isCoinTypeChange = currentDenom.coinFlag !== coinFlag || currentDenom.icon !== denomId;
        
        this.denominationData[parentIndex].denominations[denominationIndex].icon = denomId;
        this.denominationData[parentIndex].denominations[denominationIndex].faceValue = faceValue;
        this.denominationData[parentIndex].denominations[denominationIndex].ledgerDenomBalance = ledgerDenomBalance;
        this.denominationData[parentIndex].denominations[denominationIndex].coinFlag = coinFlag || 0;
        this.denominationData[parentIndex].denominations[denominationIndex].symbol = symbol || this.currencySymbol;
        this.selectedDenomination[imageIndex] = this.filterDenomination[imageIndex].denominationId;
        this.denominationData[parentIndex].denominations[denominationIndex].isOpen = false;
        
        // Only reset values if changing between coin and cash types
        if (isCoinTypeChange) {
            this.denominationData[parentIndex].denominations[denominationIndex].amount = null;
            this.denominationData[parentIndex].denominations[denominationIndex].units = null;
            this.denominationData[parentIndex].denominations[denominationIndex].inputValue = null;
            this.calculateAmount(parentIndex);
        }

        this.checkAmount(parentIndex, denominationIndex, ledgerDenomBalance, amount, faceValue, coinFlag)
        this.removeAlreadyUsedDenom(parentIndex);
        // if (amount) this.adHocPackPreview(parentIndex);
    }

    calculateAmount(parentIndex, denominationIndex) {
        this.totalDenominationsAmount = 0;
        this.denominationData[parentIndex].denominations.map((data) => {
            if (data.coinFlag && data.units) {
                // For coins: totalAmount = units * faceValue
                let coinAmount = Number(data.units * data.faceValue || 0);
                this.totalDenominationsAmount = Number(this.totalDenominationsAmount) + coinAmount;
            } else if (!data.coinFlag && data.amount) {
                // For cash: totalAmount = amount (already in currency)
                this.totalDenominationsAmount = Number(this.totalDenominationsAmount) + Number(data.amount || 0);
            }
        })
        this.denominationData[parentIndex].totalAmount = this.totalDenominationsAmount;
    }

    validateAmount(parentIndex, denominationIndex, ledgerDenomBalance, inputValue, faceValue, coinFlag) {
        // For coins, store the inputValue as units
        if (coinFlag) {
            this.denominationData[parentIndex].denominations[denominationIndex].units = Number(inputValue);
            this.denominationData[parentIndex].denominations[denominationIndex].amount = null;
        } else {
            // For cash, store the inputValue as amount
            this.denominationData[parentIndex].denominations[denominationIndex].amount = Number(inputValue);
            this.denominationData[parentIndex].denominations[denominationIndex].units = null;
        }
        
        this.calculateAmount(parentIndex);
        this.checkAmount(parentIndex, denominationIndex, ledgerDenomBalance, inputValue, faceValue, coinFlag);
    }

    // validate amount to make sure it will not exceeds current ledger denomination balance
    checkAmount(parentIndex, denominationIndex, ledgerDenomBalance, amount, faceValue, coinFlag) {
        if (parentIndex === undefined) return;

        let currentDenomId = this.denominationData[parentIndex].denominations[denominationIndex].icon;
        let otherRowsAmount = 0;
        this.denominationData.forEach((row, idx) => {
            if (idx < parentIndex) {
                let denom = row.denominations.find(d => d.icon === currentDenomId);
                if (denom) {
                    otherRowsAmount += denom.coinFlag ? (Number(denom.units || 0) * denom.faceValue) : Number(denom.amount || 0);
                }
            }
        });
        ledgerDenomBalance = ledgerDenomBalance - otherRowsAmount;

        if (coinFlag) {
            // For coins: validate calculated amount (units * faceValue) against balance
            let calculatedAmount = amount * faceValue;
            if (calculatedAmount > ledgerDenomBalance) {
                this.denominationData[parentIndex].denominations[denominationIndex].isValid = false;
            } else if (amount && amount > 0) {
                this.denominationData[parentIndex].denominations[denominationIndex].isValid = true;
            } else {
                this.denominationData[parentIndex].denominations[denominationIndex].isValid = false;
            }
        } else {
            // For cash: validate amount is divisible by faceValue
            if (amount % faceValue > 0 || amount > ledgerDenomBalance) {
                this.denominationData[parentIndex].denominations[denominationIndex].isValid = false;
            } else if (amount && amount % faceValue == 0) {
                this.denominationData[parentIndex].denominations[denominationIndex].isValid = true;
            } else {
                this.denominationData[parentIndex].denominations[denominationIndex].isValid = false;
            }
        }

        // Also trigger checkAmount for other rows with the same denomination if this is not a sub-call
        if (!this._isChecking) {
            this._isChecking = true;
            this.denominationData.forEach((row, idx) => {
                if (idx !== parentIndex) {
                    let dIdx = _.findIndex(row.denominations, { icon: currentDenomId });
                    if (dIdx !== -1) {
                        let denom = row.denominations[dIdx];
                        let val = denom.coinFlag ? denom.units : denom.amount;
                        this.checkAmount(idx, dIdx, denom.ledgerDenomBalance, val, denom.faceValue, denom.coinFlag);
                    }
                }
            });
            this._isChecking = false;
        }
    }

    validatePackButton(index) {
        let data = this.denominationData[index].denominations;

        var disableButton = data.map((denom) => {
            return (denom.isValid !== undefined && denom.isValid) || 'isEmpty'
        })
            .indexOf('isEmpty') !== -1;

        return disableButton
    }

    isTableScrollable() {
        let el = document.getElementById('deposit-packing-table-container');
        if (el) {
            return el.scrollHeight > el.clientHeight;
        }
        return false;
    }

    resetDenomData() {
        this.model.trackingId = "";
        delete this.packPreviewError;
        this.model.adHocPackPreviewData = [];
        this.isWarning = false;
    }

    adHocPack(index) {
        if (!this.model.deliveryLocation) {
            this.Modal.errorModal('Please select a delivery location');
            return;
        }
        if (!this.model.routeId) {
            this.Modal.errorModal('Please enter a route ID');
            return;
        }
        if (!this.model.deliveryDate) {
            this.Modal.errorModal('Please select a delivery date');
            return;
        }

        let hasEmptyTracking = this.denominationData.some(d => !d.trackingId);
        if (hasEmptyTracking) {
            this.Modal.errorModal('Please ensure all shipments have a Tracking ID.');
            return;
        }

        let trackingIds = this.denominationData.map(d => d.trackingId).join(', ');

        this.Modal.confirmSupervisor('ad-hoc-pack', { trackingId: trackingIds }, ({ modal, supId }) => {
            this.adHocPackLoader = true;
            const carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
            const toLocationId = this.model.deliveryLocation ? this.model.deliveryLocation.id : null;
            const routeId = this.model.routeId || null;
            const deliveryDate = this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null;

            let deposits = this.denominationData.map((data, index) => {
                return {
                    trackingId: data.trackingId,
                    amounts: this.amountMapping(index)
                };
            });

            this.AtmResidualDepositService.adHocPack(this.model.branch, this.model.fundingSourceId.Value, this.model.currency,
                this.model.account, carrierId, supId, deposits, toLocationId, routeId, deliveryDate)
                .then(() => {
                    this.model.deliveryLocation = null;
                    this.model.routeSelection = null;
                    this.model.routeId = null;
                    this.model.routeName = null;
                    this.model.deliveryDate = this.model.vaultDate;
                    this.resetDenomData();
                    this.model.fundingSourceId.manualDeposit ? this.getLedgerDenomBalance() : this.getEmergencyPackingData();
                    this.pendingToRelease();
                    this.showReleasedDeposit();
                    this.Sound.playSuccessBeep("#success_beep");
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                        this.Modal.errorModal('error.95001')
                    }
                    else if (err && err.data && err.data.message) {
                        this.Modal.errorModal(this.buildErrorMessage(err));
                    }
                })
                .finally(() => {
                    modal.close();
                    this.adHocPackLoader = false;
                })
        }, ({ modal }) => {
            modal.close();
            this.adHocPackLoader = false;
        })
    }

    validatePackAllButton() {
        if (!this.denominationData || !this.denominationData.length) return true;
        let isInvalid = false;
        this.denominationData.forEach((data, index) => {
            if (!data.trackingId || !data.denominations || !data.denominations.length || data.isDuplicateTrackingId) {
                isInvalid = true;
            } else if (this.validatePackButton(index)) {
                isInvalid = true;
            }
        });
        return isInvalid;
    }

    focuseElementById(id) {
        setTimeout(() => {
            document.getElementById(id).focus()
        }, 300);
    }

    // set focus on amount when denomination add
    setFocus(index) {
        this.focuseElementById(`denomBox-${index + 1}`);
    }

    isManualDeposit() {
        return this.model.fundingSourceId && this.model.fundingSourceId.manualDeposit;
    }

    isFundingSourceValid() {
        let isValid = ((this.isResidualDeposit() && this.isManualDeposit()) || (!this.isResidualDeposit() && !this.isManualDeposit())) ? false : true;
        return isValid;
    }

    adHocPackPreview(index) {
        let amounts = this.amountMapping(index);
        this.isLoadingPackPreview = true;

        this.AtmResidualDepositService.adHocPackPreview(this.model.branch, this.model.fundingSourceId.Value, this.model.currency, this.model.account, amounts)
            .then((data) => {
                this.model.adHocPackPreviewData = data;
                this.isWarning = data.warnings.length ? true : false;
                delete this.packPreviewError;
            })
            .catch((err) => {
                console.log(err);
                this.packPreviewError = err.data.message;
            })
            .finally(() => {
                this.isLoadingPackPreview = false;
            })
    }

    amountMapping(index) {
        let amounts = {};
        this.denominationData[index].denominations.forEach((info) => {
            if (info.icon) {
                if (info.coinFlag && info.units) {
                    // For coins: send units * faceValue as amount
                    let coinAmount = info.units * info.faceValue;
                    amounts[info.icon] = coinAmount;
                } else if (!info.coinFlag && info.amount) {
                    // For cash: send amount directly
                    amounts[info.icon] = info.amount;
                }
            }
        })
        return amounts;
    }

    validateMsg(index) {
        let denomLength = this.denominationData[index].denominations.length;
        if (!denomLength) {
            this.model.adHocPackPreviewData = [];
            this.isWarning = false;
            delete this.packPreviewError;
        }
    }

    goToItemHistory(trackingId) {
        this.Navigation.goToItemHistory(trackingId, null);
    }

    goToServiceHistory(data) {
        this.Navigation.goToServiceHistory(data.locationId, null, true, null);
    }

    loadDepositPacking() {
        let findFundingSource;
        if ((this.cashDepositData && this.cashDepositData.isRedirected) || (this.locationLists.length === 1)) {
            if (this.cashDepositData) {
                findFundingSource = _.find(this.locationLists, { Id: this.cashDepositData.fundingSourceId });
                this.model.dateRanges.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                this.model.dateRanges.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
            }
            this.model.fundingSourceId = {
                Key: findFundingSource ? findFundingSource.Key : this.locationLists[0].Key,
                Value: findFundingSource ? findFundingSource.Value : this.locationLists[0].Value,
                Id: findFundingSource ? findFundingSource.Id : this.locationLists[0].Id,
                residualDeposit: findFundingSource ? findFundingSource.residualDeposit : this.locationLists[0].residualDeposit,
                manualDeposit: findFundingSource ? findFundingSource.manualDeposit : this.locationLists[0].manualDeposit,
                partialECDeposit: findFundingSource ? findFundingSource.partialECDeposit : this.locationLists[0].partialECDeposit
            }
            this.model.account = 'regular';
            if (this.carrierLists.length) {
                this.model.carrierId = {
                    Key: this.carrierLists[0].Key,
                    Value: this.carrierLists[0].Value,
                    Name: this.carrierLists[0].Name,
                }
            }
            if (this.cashDepositData && this.cashDepositData.isRedirected) this.model.stats = this.stats.released;
            this.loadData();
            this.resetPendingResidualData();
            this.loadManualDepositData();
        }
    }

    resetFilter() {
        if (this.cashDepositData) {
            this.cashDepositData.isRedirected = false;
            this.cashDepositData = this.DataCounter.setData();
        }
    }

    autoOpenContentModal() {
        if (this.cashDepositData && this.cashDepositData.isRedirected) {
            setTimeout(() => {
                const deposit = this.releasedDeposit.records.find(data => data.trackingId === this.cashDepositData.trackingId);
                if (deposit) this.packedDepositInfo(deposit);
                this.resetFilter();
            }, 1500)
        }
    }

    goToAtmCount(trackingId) {
        return this.Navigation.goToAtmCount(trackingId, true, null, this.model.fundingSourceId.Id);
    }

    exportReleasedDeposit(data) {
        this.isExporting = true;
        this.AtmResidualDepositService.exportReleasedDeposit(data.id)
            .then((res) => {
                this.releasedDepositData = res;
                if (this.releasedDepositData.totalRecords > 0) {
                    return this.downloadFile(this.releasedDepositData, 'released_deposit');
                }
                else {
                    return this.Modal.errorModal('common.noDataFound');
                }
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.isExporting = false;
            })
    }

    resetDenominations() {
        this.filterDenomination = [];
        this.isLimitExceed = false;
        delete this.depositLimitExceedMsg;
    }

    toggleReleasedDenominations(released) {
       
        this.releasedDeposit.records.forEach(record => {
            if (record !== released) {
                record.showDenominations = false;
            }
        });
        
        released.showDenominations = !released.showDenominations;
    }

    togglePackedDenominations(packed) {
       
        this.pendingReleaseData.records.forEach(record => {
            if (record !== packed) {
                record.showDenominations = false;
            }
        });
       
        packed.showDenominations = !packed.showDenominations;
        
    }
}

export default DepositPackingController;



// WEBPACK FOOTER //
// ./client/app/components/deposit_packing/deposit_packing.controller.js